import { BaseApiError } from './base-api-error';

export class NotAuthenticatedError extends BaseApiError {
  constructor(message = 'Not Authenticated') {
    super(message, 401);
    this.name = 'NotAuthenticatedError';
  }
}
